import { render, staticRenderFns } from "./Func8Contatos.vue?vue&type=template&id=a300fc7c"
import script from "./Func8Contatos.vue?vue&type=script&lang=js"
export * from "./Func8Contatos.vue?vue&type=script&lang=js"
import style0 from "./Func8Contatos.vue?vue&type=style&index=0&id=a300fc7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports